<template>
  <div id="contenedor-eliminar-auditoria-informe-observacion-detalle">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Desglose </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el Desglose? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{detalle.fechaVencimiento}}
          </span>
        </v-row>
        <v-row>
          <span> <cortar-texto
          :texto="detalle.texto">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarAuditoriaInformeObservacionDetalle"
          :disabled="enviandoFormulario || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import mixObservaciones from '../mixObservaciones';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContenedorEliminarAuditoriaInformeObservacionDetalle',
  props: {
    detalle: {
      type: Object,
      required: true,
    },
    observacion: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixObservaciones],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarAuditoriaInformeObservacionDetalle() {
      this.enviandoFormulario = true;
      this.mixEliminarAuditoriaInformeObservacionDetalle();
    },
  },
  computed: {
    tieneDependencias() {
      return this.observacion.detalles.length > 0;
    },
  },
};
</script>
